import { useMyFeatureFlagsQuery } from "../types";
export const useHasFeature = (flag, opts) => {
    const skip = opts?.skip ?? false;
    const { data } = useMyFeatureFlagsQuery({
        skip,
    });
    return Boolean(data && data.myFeatureFlags[flag]);
};
export const useHasFeatureWithLoading = (flag, opts) => {
    const skip = opts?.skip ?? false;
    const { data, loading } = useMyFeatureFlagsQuery({
        skip,
    });
    const value = Boolean(data && data.myFeatureFlags[flag]);
    return { value, loading };
};
//# sourceMappingURL=index.js.map